var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIdCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 11V4H1V11H14ZM15 4V11C15 11.5522 14.5523 12 14 12H1C0.447715 12 0 11.5522 0 11V4C0 3.44772 0.447715 3 1 3H14C14.5523 3 15 3.44772 15 4ZM2 5.24994C2 5.11187 2.11193 4.99994 2.25 4.99994H5.75C5.88807 4.99994 6 5.11187 6 5.24994V9.74994C6 9.88801 5.88807 9.99994 5.75 9.99994H2.25C2.11193 9.99994 2 9.88801 2 9.74994V5.24994ZM7.5 6.99994C7.22386 6.99994 7 7.2238 7 7.49994C7 7.77608 7.22386 7.99994 7.5 7.99994H10.5C10.7761 7.99994 11 7.77608 11 7.49994C11 7.2238 10.7761 6.99994 10.5 6.99994H7.5ZM7 9.49994C7 9.2238 7.22386 8.99994 7.5 8.99994H12.5C12.7761 8.99994 13 9.2238 13 9.49994C13 9.77608 12.7761 9.99994 12.5 9.99994H7.5C7.22386 9.99994 7 9.77608 7 9.49994ZM7.5 4.99994C7.22386 4.99994 7 5.2238 7 5.49994C7 5.77608 7.22386 5.99994 7.5 5.99994H11.5C11.7761 5.99994 12 5.77608 12 5.49994C12 5.2238 11.7761 4.99994 11.5 4.99994H7.5Z",
    fill: "#1C2024"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdCard);
export default __webpack_public_path__ + "static/media/id-card.b67c5a3de8fd5272318ecc3aa22c7f77.svg";
export { ForwardRef as ReactComponent };